























import {Component, Prop, Vue} from 'vue-property-decorator';
import {ISupplier} from '@/models/ISupplier';

@Component({})
export default class SupplierSelect extends Vue {
  @Prop() value: ISupplier;
  @Prop() suppliers: ISupplier[];

  onChange(value: number) {
    this.$emit('input', value);
  }
}
